"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToMonthYearString = void 0;
const transformDateToMonthNameString_1 = require("./transformDateToMonthNameString");
function transformDateToMonthYearString(date) {
    const dateToString = new Date(date);
    const year = dateToString.getUTCFullYear().toString();
    const month = (0, transformDateToMonthNameString_1.transformDateToMonthNameString)(dateToString);
    return `${month}, ${year}`;
}
exports.transformDateToMonthYearString = transformDateToMonthYearString;
//# sourceMappingURL=transformDateToMonthYearString.js.map